import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/* eslint-disable jsx-a11y/label-has-associated-control */
import { useState } from 'react';
import { css } from '@emotion/react';
import { border, background, textSans, space, } from '@guardian/source-foundations';
import { Button, SvgCheckmark } from '@guardian/source-react-components';
const roleTextSize = (role) => {
    switch (role) {
        case 'immersive':
        case 'inline':
        case 'showcase': {
            return textSans.medium({ lineHeight: 'regular' });
        }
        case 'halfWidth':
        case 'supporting':
        case 'thumbnail': {
            return textSans.small({ lineHeight: 'regular' });
        }
    }
};
const roleHeadlineSize = (role) => {
    switch (role) {
        case 'immersive':
        case 'inline':
        case 'showcase': {
            return textSans.large({
                fontWeight: 'bold',
                lineHeight: 'regular',
            });
        }
        case 'halfWidth':
        case 'supporting':
        case 'thumbnail': {
            return textSans.medium({
                fontWeight: 'bold',
                lineHeight: 'regular',
            });
        }
    }
};
const roleButtonSize = (role) => {
    switch (role) {
        case 'immersive':
        case 'inline':
        case 'showcase': {
            return 'default';
        }
        case 'halfWidth':
        case 'supporting':
            return 'small';
        case 'thumbnail': {
            return 'xsmall';
        }
    }
};
const roleButtonText = (role) => {
    switch (role) {
        case 'immersive':
        case 'inline':
        case 'showcase':
        case 'halfWidth':
        case 'supporting': {
            return 'Allow and continue';
        }
        case 'thumbnail': {
            return 'Allow';
        }
    }
};
const shouldDisplayOverlay = ({ isTracking, isOverlayClicked, isMainMedia, }) => {
    if (isMainMedia || !isTracking) {
        return false;
    }
    if (isOverlayClicked) {
        return false;
    }
    return true;
};
export const ClickToView = ({ children, role = 'inline', onAccept, isTracking, isMainMedia, source, sourceDomain = 'unknown', }) => {
    const [isOverlayClicked, setIsOverlayClicked] = useState(false);
    const handleClick = () => {
        setIsOverlayClicked(true);
        if (onAccept) {
            setTimeout(() => onAccept());
        }
    };
    const textSize = roleTextSize(role);
    if (shouldDisplayOverlay({
        isTracking,
        isOverlayClicked,
        isMainMedia,
    })) {
        return (_jsxs("div", Object.assign({ css: css `
					width: 100%;
					background: ${background.secondary};
					border: 1px solid ${border.secondary};
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					padding: ${space[1]}px ${space[6]}px ${space[3]}px;
					margin-bottom: ${space[3]}px;
				`, "data-component": `click-to-view:${sourceDomain}` }, { children: [_jsx("div", Object.assign({ css: css `
						${roleHeadlineSize(role)}
						margin-bottom: ${space[1]}px;
					` }, { children: source
                        ? `Allow ${source} content?`
                        : 'Allow content provided by a third party?' }), void 0), _jsx("p", Object.assign({ css: css `
						${textSize}
					` }, { children: source ? (_jsxs(_Fragment, { children: ["This article includes content provided by ", source, ". We ask for your permission before anything is loaded, as they may be using cookies and other technologies. To view this content,", ' ', _jsx("strong", { children: "click 'Allow and continue'" }, void 0), "."] }, void 0)) : (_jsxs(_Fragment, { children: ["This article includes content hosted on", ' ', sourceDomain, ". We ask for your permission before anything is loaded, as the provider may be using cookies and other technologies. To view this content,", ' ', _jsx("strong", { children: "click 'Allow and continue'" }, void 0), "."] }, void 0)) }), void 0), _jsx("div", Object.assign({ css: css `
						margin-top: ${space[5]}px;
					` }, { children: _jsx(Button, Object.assign({ priority: "primary", size: roleButtonSize(role), icon: _jsx(SvgCheckmark, {}, void 0), iconSide: "left", onClick: () => handleClick(), "data-cy": "click-to-view-button", "data-link-name": "allow-button" }, { children: roleButtonText(role) }), void 0) }), void 0)] }), void 0));
    }
    return _jsx(_Fragment, { children: children }, void 0);
};
